// extracted by mini-css-extract-plugin
export default {"filters":"CohortCollection_filters__XjWbH","filters_wrap":"CohortCollection_filters_wrap__wp2ET","radio":"CohortCollection_radio__M6OtP","input":"CohortCollection_input__Z8JOv"};